import React from 'react';
import './Footer.css';

export default function Footer({ navigate }) {
  return (
    <footer className="footer">
      <div className="footer-glow" />
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo" onClick={() => navigate('home')}>
              <img src="/bee-logo-pink.png" alt="HiveeClub" className="footer-logo-img" />
            </div>
            <p className="footer-tagline">Hottest and trendiest social<br/>ticketing entertainment platform.</p>
            <div className="footer-stores">
              <a href="https://apps.apple.com/au/app/hiveeclub/id1584271794" target="_blank" rel="noopener noreferrer" className="store-badge apple">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
                <div><span>Download on the</span><strong>App Store</strong></div>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.hivee.hivee" target="_blank" rel="noopener noreferrer" className="store-badge google">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M3.18 23.76c.33.18.7.24 1.08.17l12.29-7.08-2.6-2.6-10.77 9.51zm-1.06-1.38V1.62L13.64 12 2.12 22.38zm17.3-11.43L16.8 9.4 14 12l2.8 2.8 2.66-1.54a1.5 1.5 0 0 0 0-2.52zM4.26.07L16.55 7.15 13.95 9.75 3.18.24A1.5 1.5 0 0 0 4.26.07z"/></svg>
                <div><span>Get it on</span><strong>Google Play</strong></div>
              </a>
            </div>
          </div>

          <div className="footer-links">
            <div className="link-group">
              <h4>Useful Links</h4>
              <ul>
                {[['home','Home'],['about','About'],['faq','FAQ'],['contact','Contact']].map(([page,label]) => (
                  <li key={page}><button onClick={() => navigate(page)}>{label}</button></li>
                ))}
              </ul>
            </div>
            <div className="link-group">
              <h4>Legal</h4>
              <ul>
                <li><button onClick={() => navigate('privacy')}>Privacy Policy</button></li>
                <li><button onClick={() => navigate('terms')}>Terms &amp; Conditions</button></li>
              </ul>
            </div>
            <div className="link-group">
              <h4>Get In Touch</h4>
              <ul>
                <li><a href="mailto:info@hivee.app">info@hivee.app</a></li>
              </ul>
              {/* Social icons temporarily hidden */}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2021–2026 HiveeClub. All Rights Reserved.</p>
          <p className="footer-email">info@hivee.app</p>
        </div>
      </div>
    </footer>
  );
}
